import { gql, useQuery } from '@apollo/client'
import { D4_Personne, D4_Sms } from '../../types'
import Table, { ColumnsType } from 'antd/es/table'
import dayjs from 'dayjs'
import { DATE_FORMAT } from '../../constants'

const SMS_QUERY = gql`
  query SMS($personneId: bigint!) {
    d4_sms(where: { personne_id: { _eq: $personneId } }) {
      id
      message
      numero
      gestionnaire_id
      created_at
      type
      gestionnaire {
        nom
        prenom
      }
    }
  }
`

const columns: ColumnsType<D4_Sms> = [
  {
    title: 'Message',
    dataIndex: 'message',
  },
  {
    title: 'Type',
    dataIndex: 'type',
  },
  {
    title: 'Numéro',
    dataIndex: 'numero',
  },
  {
    title: 'Envoyé le',
    dataIndex: 'createdAt',
    render: (text) => dayjs(text).format(DATE_FORMAT),
  },
  {
    title: 'Envoyé par',
    dataIndex: 'gestionnaire',
    render: (personne: D4_Personne) => `${personne.prenom} ${personne.nom}`,
  },
]

const SmsTable = ({ personneId }: { personneId: number }) => {
  const { data } = useQuery<{ d4_sms: D4_Sms }, { personneId: number }>(SMS_QUERY, { variables: { personneId } })
  //@ts-expect-error
  return <Table dataSource={data?.d4_sms} columns={columns} />
}

export default SmsTable
